import { KeyValues } from '../key-value';

export class Errors {
  public errors: KeyValues = new KeyValues();
}
